export const drawVirtual = () => {
    function virtualOverlay(info, size) {
        this._info = info;
        this._width = size;
    }
    virtualOverlay.prototype.station = 'station info'
    virtualOverlay.prototype = new BMapLite.Overlay();
    virtualOverlay.prototype.initialize = function (map) {
        this._map = map;
        var div = this._div = document.createElement("div");
        div.style.position = "absolute";
        div.style.zIndex = BMapLite.Overlay.getZIndex(this._info.Lat);
        div.style.backgroundImage = "url('static/icon/virtual_device.gif')";
        div.style.backgroundSize = "100% 100%";
        div.style.border = "1px solid #333";
        div.style.width = this._width + "px";
        div.style.height = this._width + "px";
        div.style.borderRadius = "50%";
        div.style.cursor = "pointer";
        map.getPanes().markerPane.appendChild(div);
        return div;
    }
    virtualOverlay.prototype.draw = function () {
        var map = this._map;
        var point = new BMapLite.Point(this._info.Lng, this._info.Lat);
        var pixel = map.pointToOverlayPixel(point);
        this._div.style.left = pixel.x - this._width/2 + "px";
        this._div.style.top = pixel.y - this._width/2 + "px";
    }
    virtualOverlay.prototype.addEventListener = function (event, fun) {
        this._div['on'+event] = fun;
    }

    return virtualOverlay
}

export const drawStation = () => {
    function stationOverlay(info, size, color) {
        this._info = info;
        this._width = size;
        this._color = color
    }
    stationOverlay.prototype.station = 'station info'
    stationOverlay.prototype = new BMapLite.Overlay();
    stationOverlay.prototype.initialize = function (map) {
        this._map = map;
        var div = this._div = document.createElement("div");
        div.style.position = "absolute";
        div.style.zIndex = BMapLite.Overlay.getZIndex(this._info.path.Lat);
        div.style.backgroundColor = this._color;
        div.style.backgroundImage = "url('static/icon/wind.png')";
        div.style.backgroundSize = "100% 100%";
        div.style.border = "1px solid #333";
        div.style.width = this._width + "px";
        div.style.height = this._width + "px";
        div.style.borderRadius = "50%";
        div.style.transform = `rotate(${this._info.sensor.wind_direction}deg)`;
        div.style.cursor = "pointer";

        map.getPanes().markerPane.appendChild(div);
        return div;
    }
    stationOverlay.prototype.draw = function () {
        var map = this._map;
        var point = new BMapLite.Point(this._info.path.Lng, this._info.path.Lat);
        var pixel = map.pointToOverlayPixel(point);
        this._div.style.left = pixel.x - this._width/2 + "px";
        this._div.style.top = pixel.y - this._width/2 + "px";
    }
    stationOverlay.prototype.addEventListener = function (event, fun) {
        this._div['on'+event] = fun;
    }

    return stationOverlay
}

export const drawStationInfowindow = () => {
    function stationInfoOverlay(info, size) {
        this._info = info;
        this._pm10_sensor = this._info.sensor.pm10 > 0 ? this._info.sensor.pm10 : '--'
        this._pm25_sensor = this._info.sensor.pm25 > 0 ? this._info.sensor.pm25 : '--'
        this._wind_speed = this._info.sensor.wind_speed > 0 ? this._info.sensor.wind_speed : '--'
        this._width = size;
    }
    stationInfoOverlay.prototype.station = 'station info'
    stationInfoOverlay.prototype = new BMapLite.Overlay();
    stationInfoOverlay.prototype.initialize = function (map) {
        this._map = map;
        var div = this._div = document.createElement("div");
        div.style.position = "absolute";
        div.style.zIndex = BMapLite.Overlay.getZIndex(this._info.path.Lat);
        div.style.backgroundColor = "#fff";
        div.style.border = "1px solid #ccc";
        div.style.width = 5 * this._width + "px";
        div.style.height = 2.8 * this._width + "px";
        div.style.borderRadius = "5px";

        var div2 = this._div2 = document.createElement("div");
        div2.appendChild(document.createTextNode("PM₁₀：" + this._pm10_sensor))
        div2.style.height = '18px'
        div2.style.fontSize = '12px'
        div2.style.textIndent = '6px'
        div.appendChild(div2)

        var div3 = this._div3 = document.createElement("div");
        div3.appendChild(document.createTextNode("PM₂.₅：" + this._pm25_sensor))
        div3.style.fontSize = '12px'
        div3.style.textIndent = '6px'
        div.appendChild(div3)

        map.getPanes().markerPane.appendChild(div);
        return div;
    }
    stationInfoOverlay.prototype.draw = function () {
        var map = this._map;
        var point = new BMapLite.Point(this._info.path.Lng, this._info.path.Lat);
        var pixel = map.pointToOverlayPixel(point);
        this._div.style.left = pixel.x - 2.5 * this._width + "px";
        this._div.style.top = pixel.y - 3.6 * this._width + "px";
    }
    // 实现显示方法    
    stationInfoOverlay.prototype.show = function() {    
        if (this._div) {    
            this._div.style.display = "";    
        }    
    }      
    // 实现隐藏方法  
    stationInfoOverlay.prototype.hide = function() {    
        if (this._div) {    
            this._div.style.display = "none";    
        }    
    }
    stationInfoOverlay.prototype.addEventListener = function (event, fun) {
        this._div['on'+event] = fun;
    }

    return stationInfoOverlay
}


// WEBPACK FOOTER //
// ./src/pages/application/virtual/utils.js